import { Meta, theme } from 'aimo-ui';
import TouchableItem from 'components/common/TouchableItem';
import Icon from 'components/icons/Icon';
import { useTranslation } from 'react-i18next';
import { useSearchStore } from 'stores/searchStore';
import styled from 'styled-components/native';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { EvseConnector } from 'types/generatedSchemaTypes';
import { isAvailableChargingStationSpot } from 'utils/chargingUtils';

import useSelectParkingZone from 'hooks/useSelectParkingZone';
import { testIdentifiers } from 'utils/testIdentifiers';
import PublicDisplayId from '../evcharge/PublicDisplayId';
import { StatusText } from '../evcharge/chargerSelection/SelectParkAndChargeItem';
import { Row } from '../styles/styles';

type ChargerSearchItemProps = {
  item: EvseConnector;
};

const ItemRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ItemColumn = styled.View`
  flex: 1;
  flex-direction: column;
  gap: 5px;
`;

const ContentColumn = styled.View`
  flex: 1;
  flex-direction: column;
  gap: 3px;
  margin-left: 10px;
`;

const ChargerSearchItem = ({ item }: ChargerSearchItemProps) => {
  const { handleParkZoneSelected } = useSelectParkingZone();
  const {
    parkZone,
    parkingZoneUid,
    publicDisplayId,
    socketStatus,
    power,
    type = undefined,
  } = item ?? {};

  const { t } = useTranslation();
  const isAvailable = isAvailableChargingStationSpot(socketStatus);

  const { setSelectedConnector } = useSearchStore((state) => state);
  const testID = `charger-search-item-${parkingZoneUid}`;
  const onPress = () => {
    setSelectedConnector(item);
    if (parkingZoneUid) {
      handleParkZoneSelected(
        parkingZoneUid,
        undefined,
        false,
        undefined,
        false
      );
    }
  };
  const powerText = power ? `${power}kW` : '';
  const typeText = type ? t(`evCharging.connectorSupportedTypes.${type}`) : '';
  return (
    <TouchableItem
      disabled={!isAvailable}
      onPress={onPress}
      {...testIdentifiers(testID)}>
      <ItemRow>
        <ItemColumn>
          <Row>
            <PublicDisplayId
              testID={`${testID}-public-display-id`}
              publicDisplayId={publicDisplayId ?? ''}
              isAvailable={isAvailable}
            />
            <ContentColumn>
              <Row mb={0} mt={0}>
                <StatusText
                  disabled={!isAvailable}
                  testID={testID}
                  status={socketStatus}
                />
                <Meta
                  color={
                    theme.colors.gray300
                  }>{` • ${powerText} • ${typeText}`}</Meta>
              </Row>
              <Meta
                color={theme.colors.gray300}
                {...testIdentifiers(`${testID}-parkzone-name`)}>
                {parkZone?.commercialZoneView?.name}
              </Meta>
            </ContentColumn>
          </Row>
        </ItemColumn>

        <ColumnWithMargins
          ml={10}
          {...testIdentifiers(`select-charger-${parkingZoneUid}`)}>
          <Icon size={'m'} name="Chevron_Right" />
        </ColumnWithMargins>
      </ItemRow>
    </TouchableItem>
  );
};

export default ChargerSearchItem;
